import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getVPUData,
  getVPUDivisionDeptByVendor,
  getVPUReport,
  getVPUTableData,
  getVPUVendorDetails,
} from "../api/vpu";

export const fetchVPUData = createAsyncThunk(
  "vpu/fetchVPUData",
  async (params) =>
    getVPUData(
      params?.aggr,
      params?.location,
      params?.division,
      params?.department,
      params?.vendor,
      params?.page,
      params?.limit,
      params?.sort,
      params?.sort_by,
      params?.backorder
    ).then((res) => res)
);

export const fetchVPUTableData = createAsyncThunk(
  "vpu/fetchVPUTableData",
  async (params) =>
    getVPUTableData(
      params?.location,
      params?.division,
      params?.department,
      params?.vendor,
      params?.part,
      params?.page,
      params?.limit,
      params?.backorder,
      params?.case
    ).then((res) => res)
);

export const fetchVPUReport = createAsyncThunk(
  "vpu/fetchVPUReport",
  async (params) =>
    getVPUReport(
      params?.location,
      params?.division,
      params?.department,
      params?.vendor,
      params?.part,
      params?.backorder,
      params?.case
    ).then((res) => res)
);

export const fetchVPUVendorDetails = createAsyncThunk(
  "vpu/fetchVPUVendorDetails",
  async (params) =>
    getVPUVendorDetails(
      params?.division,
      params?.department,
      params?.page,
      params?.limit,
      params?.search
    ).then((res) => res)
);

export const fetchDivisionDeptByVendor = createAsyncThunk(
  "vpu/fetchDivisionDeptByVendor",
  async (params) => getVPUDivisionDeptByVendor(params?.vendor).then((res) => res)
);

export const vpuSlice = createSlice({
  name: "vpu",
  initialState: {
    vpuDetails: [],
    vpuTableDetails: [],
    vpuReport: null,
    vpuVendorDetails: null,
    vpuVendorDetailsLoading: false,
    vpuDivisionDeptListByVendor: null,
    vpuDivisionDetailsLoading: false,
    loading: false,
  },
  extraReducers: {
    [fetchVPUData.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchVPUData.fulfilled]: (state, { payload }) => {
      state.vpuDetails = payload;
      state.loading = false;
    },
    [fetchVPUData.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchVPUTableData.fulfilled]: (state, { payload }) => {
      state.vpuTableDetails = payload;
    },
    [fetchVPUReport.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchVPUReport.fulfilled]: (state, { payload }) => {
      state.vpuReport = payload;
      state.loading = false;
    },
    [fetchVPUReport.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchVPUVendorDetails.pending]: (state, { payload }) => {
      state.vpuVendorDetailsLoading = true;
    },
    [fetchVPUVendorDetails.fulfilled]: (state, { payload }) => {
      state.vpuVendorDetails = payload;
      state.vpuVendorDetailsLoading = false;
    },
    [fetchVPUVendorDetails.rejected]: (state, { payload }) => {
      state.vpuVendorDetailsLoading = false;
    },
    [fetchDivisionDeptByVendor.pending]: (state, { payload }) => {
      state.vpuDivisionDetailsLoading = true;
    },
    [fetchDivisionDeptByVendor.fulfilled]: (state, { payload }) => {
      state.vpuDivisionDeptListByVendor = payload;
      state.vpuDivisionDetailsLoading = false;
    },
    [fetchDivisionDeptByVendor.rejected]: (state, { payload }) => {
      state.vpuDivisionDetailsLoading = false;
    },
  },
});

export default vpuSlice.reducer;
